
// Helpers
import { getFileName } from "../helpers";

export const TransactionMapper = {

    transformFileInfo: (files) => {

        if ( !files ) { return []; } 

        return files.map(f => {

            const name = getFileName(f.link);
            const id = `${name.split('.')[0] } - ${ f.date }`;
            return {
                id,
                name,
                url: f.link
            }
        });
    }
};